export enum QueryParams {
  PAGE = "page",
  ZIP = "zip",
  FILTERS = "filters",
  LAT_LNG = "latLng",
  SEARCH = "search",
}
